import {
  HTTP_REPORTMANAGERBYBRAND_FETCHING,
  HTTP_REPORTMANAGERBYBRAND_SUCCESS,
  HTTP_REPORTMANAGERBYBRAND_FAILED,
} from "././../../Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_REPORTMANAGERBYBRAND_FETCHING:
      return {
        ...state,
        result: [],
        isFetching: true,
        isError: false,
      };
    case HTTP_REPORTMANAGERBYBRAND_SUCCESS:
      return {
        ...state,
        result: payload,
        isFetching: false,
        isError: false,
      };
    case HTTP_REPORTMANAGERBYBRAND_FAILED:
      return {
        ...state,
        result: [],
        isFetching: false,
        isError: true,
      };
    default:
      return state;
  }
};
